<div *ngIf="seccion === 'L'">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <h1 class="titulo-pagina">{{ 'ZONES.LBL_ZONES' | translate}}</h1>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
              <button type="button" pButton icon="fa fa-plus" (click)="crearZona()" *ngIf="menu.agregar && idEstructuraFisica"
                      label="{{ 'BTN_AGREGAR' | translate}}"></button>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                     (input)="dt.filterGlobal($event.target.value, 'contains')"
                     [(ngModel)]="busqueda" (change)="setSearch()">
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <p-table [columns]="columnas" [loading]="loadingZones" #dt
                       [value]="zones" selectionMode="single" dataKey="idZona"
                       [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr [pSelectableRow]="row">
                    <td>{{row.codigo}}</td>
                    <td>{{row.nombre}}</td>
                    <td>{{row.clasificacionZona}}</td>
                    <td class="text-center">
                      <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                    </td>
                    <td class="text-center">
                      <div class="btn-group" role="group" *ngIf="!validandoIndicador">
                        <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                                title="{{'BTN_VISUALIZAR' | translate}}"
                                pButton (click)="verZona(row)"></button>
                        <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                                title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                                (click)="editarZona(row)"></button>
                        <button type="button" class="p-button deep-orange-btn btn" icon="fa fa-lock" data-toggle="tooltip"
                                title="{{'ZONES.BTN_LIBERAR' | translate}}" pButton
                                (click)="liberarZona(row)" *ngIf="row.indicadorDescargado !== null && row.indicadorDescargado === true"></button>
                      </div>
                      <div class="grid" *ngIf="validandoIndicador">
                        <div class="col-12 md:col-12 lg:col-12 text-center">
                          <i class="fa fa-refresh fa-spin fa-fw"></i>
                          <span>{{ 'LBL_VALIDANDO' | translate}}...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="columns.length" class="text-center">
                      {{ 'MSG_NOHAYREGISTROS' | translate}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

<app-zonas-detalle [zone]="zonSeleccionada" (cerrar)="cambiosComponentes($event)" *ngIf="seccion=='V'"></app-zonas-detalle>

<app-zonas-editar [zone]="zonSeleccionada" [idEstructuraFisica]="idEstructuraFisica" (cerrar)="cambiosComponentes($event)" *ngIf="seccion=='C' || seccion=='E'"></app-zonas-editar>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="mostrarDialogoCausal"
          [contentStyle]="{'width':'600px'}"
          header="{{ 'ZONES.LBL_SELECCIONARCAUSAL' | translate}}"
          [modal]="true">
  <div class="grid" *ngIf="carInformacionDialogoCausal">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>

  <div class="grid form-group" *ngIf="!carInformacionDialogoCausal">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="forCausalLiberacion" (ngSubmit)="liberacionZona()" novalidate id="fCausalLiberacion" name="fCausalLiberacion">
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_CAUSAL' | translate }}</label>
              <p-dropdown disableTab  id="idCausalLiberacion" name="nomCausalLiberacion" [options]="lisCausalesLiberacion" optionLabel="nombre"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idCausalLiberacion"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="forCausalLiberacion.controls.idCausalLiberacion.invalid && causalSubmitted">
                {{ 'ZONES.MSG_CAUSALREQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_OBSERVACIONES' | translate }}</label>
              <textarea pInputTextarea rows="2" id="idObservaciones"
                        name="nomObservaciones"
                        autocomplete="off"
                        formControlName="observacion"
                        [maxlength]="500"
                        capitalize-reactive
              ></textarea>
              <div class="p-message p-messages-error p-corner-all" *ngIf="forCausalLiberacion.controls.observacion.invalid && causalSubmitted">
                {{ 'ZONES.LBL_OBSERVACIONES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guaCausal">
              <a (click)="cancelarLiberacion(forCausalLiberacion.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-unlock-alt "
                      label="{{'ZONES.BTN_LIBERAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guaCausal">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
